<template>
  <v-layout class="view-wrapper" justify-center align-center wrap>
    <p class="headline heading text-xs-center">{{$t('View')}}</p>
    <v-flex xs-3 class="view-item text-xs-center">
      <h5 class="headline count purple--text">25 {{$t('Views')}}</h5>
      <h5 class="headline price">
        <span>$</span>19
      </h5>
      <v-btn v-if="!checkDeviceId" dark color="purple" @click="showAlert">buy videos</v-btn>
      <chargeBtn
        v-if="checkDeviceId"
        plan="plan1"
        :device_id="device_id"
        :amount="stripeBtn.plan1.amount"
        :currency="stripeBtn.plan1.currency"
        :stripeKey="stripeBtn.plan1.stripeKey"
        :email="email"
      ></chargeBtn>
    </v-flex>
    <v-flex xs-3 class="view-item text-xs-center">
      <h5 class="headline count purple--text">50 {{$t('Views')}}</h5>
      <h5 class="headline price">
        <span>$</span>30
      </h5>
      <v-btn v-if="!checkDeviceId" dark color="purple" @click="showAlert">buy videos</v-btn>
      <chargeBtn
        v-if="checkDeviceId"
        plan="plan2"
        :device_id="device_id"
        :amount="stripeBtn.plan2.amount"
        :currency="stripeBtn.plan2.currency"
        :stripeKey="stripeBtn.plan2.stripeKey"
        :email="email"
      ></chargeBtn>
    </v-flex>
    <v-flex xs-3 class="view-item text-xs-center">
      <h5 class="headline count purple--text">100 {{$t('Views')}}</h5>
      <h5 class="headline price">
        <span>$</span>50
      </h5>
      <v-btn v-if="!checkDeviceId" dark color="purple" @click="showAlert">buy videos</v-btn>
      <chargeBtn
        v-if="checkDeviceId"
        plan="plan3"
        :device_id="device_id"
        :amount="stripeBtn.plan3.amount"
        :currency="stripeBtn.plan3.currency"
        :stripeKey="stripeBtn.plan3.stripeKey"
        :email="email"
      ></chargeBtn>
    </v-flex>
    <showModal v-model="showDialog" :message="dialogMessage"></showModal>
  </v-layout>
</template>

<script>
import axios from "axios";
import chargeBtn from "@/components/chargeBtn";
import showModal from "@/components/ShowModal"
import { createStripeBtn } from "@/utils";

export default {
  name: "view",

  components: {
    chargeBtn,
    showModal
  },

  data: () => ({
    device_id: "",
    showDialog: false,
    dialogMessage: '',
    email: '',
    stripeBtn: {
      plan1: {
          amount:'',
          currency:'',
          stripeKey:''
      },
      plan2: {
          amount: '',
          currency: '',
          stripeKey: '',
      },
      plan3: {
          amount: '',
          currency: '',
          stripeKey: '',
      }
    }
  }),

  computed: {
    checkDeviceId () {
      if(this.device_id === 'no_device_id') {
         return false
      } else {
         return true
      }
    }
  },

  methods: {
    showAlert () {
      this.showDialog = true
      this.dialogMessage = 'You need to buy VR at first!'
    }
  },

  created() {
    axios.get(this.$hostname + "/stripe/credentials/plan_1").then(response => {
      console.log(response);
      this.stripeBtn.plan1.amount = response.data.data_amount;
      this.stripeBtn.plan1.currency = response.data.data_currency;
      this.stripeBtn.plan1.stripeKey = response.data.data_key;
      let btns = document.querySelectorAll("[class^=checkout-form-plan1]");
      for (let i = 0; i < btns.length; i++) {
        btns[i].appendChild(createStripeBtn(response));
      }
    });

    axios.get(this.$hostname + "/stripe/credentials/plan_2").then(response => {
      console.log(response);
      this.stripeBtn.plan2.amount = response.data.data_amount;
      this.stripeBtn.plan2.currency = response.data.data_currency;
      this.stripeBtn.plan2.stripeKey = response.data.data_key;
      let btns = document.querySelectorAll("[class^=checkout-form-plan2]");
      for (let i = 0; i < btns.length; i++) {
        btns[i].appendChild(createStripeBtn(response));
      }
    });

    axios.get(this.$hostname + "/stripe/credentials/plan_3").then(response => {
      console.log(response);
      this.stripeBtn.plan3.amount = response.data.data_amount;
      this.stripeBtn.plan3.currency = response.data.data_currency;
      this.stripeBtn.plan3.stripeKey = response.data.data_key;
      let btns = document.querySelectorAll("[class^=checkout-form-plan3]");
      for (let i = 0; i < btns.length; i++) {
        btns[i].appendChild(createStripeBtn(response));
      }
    });

    axios.get(this.$hostname + "/client/me/", {
        headers: {
          Authorization: localStorage.getItem("token")
        }
      })
    .then(response => {
      this.email = response.data.data.email
    })

    this.device_id = this.$route.params.device_id;
  }
};
</script>

<style scoped lang="scss">
.view-wrapper {
  background-color: #fff;
  min-height: 450px;
  padding-bottom: 75px;

  .heading {
    width: 100%;
    font-size: 30px;
    font-weight: 700;
  }

  .view-item {
    padding: 15px;

    .headline {
      font-weight: 900;
      text-transform: uppercase;
    }

    .count {
      margin-bottom: 40px;
    }

    .price {
      margin-bottom: 20px;

      span {
        opacity: 0.5;
      }
    }

    .v-btn {
      min-width: 180px;
    }
  }
}
</style>